module.exports = __webpack_public_path__ + "media/images/doctor_profiles/modal/sp/search_result_page/skill-46628baaebf69138ec9493f93208de0f.png";